module.exports = __webpack_public_path__ + "site/img/253.bd19719d.jpg";